module.exports = __webpack_public_path__ + "static/media/emj03.f7aa5718.svg";